module.exports = __webpack_public_path__ + "media/shipinside.14fc999d.mp4";